import {
    GENERATE_QUESTION,
    GENERATE_QUESTION_SUCCESS,
    GENERATE_QUESTION_FAILURE,
    GET_QUESTIONS,
    GET_QUESTIONS_SUCCESS,
    GET_QUESTIONS_FAILURE,
    POST_QUESTION,
    POST_QUESTION_SUCCESS,
    POST_QUESTION_FAILURE,
    DELETE_QUESTION_SET,
    DELETE_QUESTION_SET_SUCCESS,
    DELETE_QUESTION_SET_FAILURE,
    GET_QUESTION_LIBRARY,
    GET_QUESTION_LIBRARY_SUCCESS,
    GET_QUESTION_LIBRARY_FAILURE,
    GET_ALL_PERMISSION,
    GET_ALL_PERMISSION_SUCCESS,
    GET_ALL_PERMISSION_FAILURE,
    FETCH_LANGUAGE_QUESTION,
    FETCH_LANGUAGE_QUESTION_SUCCESS,
    FETCH_LANGUAGE_QUESTION_FAILURE,
    TRANSLATE_QUESTIONS,
    TRANSLATE_QUESTIONS_SUCCESS,
    TRANSLATE_QUESTIONS_FAILURE,
    FETCH_PSYCHOMETRIC_ROLES,
    FETCH_PSYCHOMETRIC_ROLES_SUCCESS,
    FETCH_PSYCHOMETRIC_ROLES_FAILURE,
} from './types';
export const fetchLanguageQuestion = (payload) => ({
    type: FETCH_LANGUAGE_QUESTION,
    payload,
});
export const fetchLanguageQuestionSuccess = () => ({
    type: FETCH_LANGUAGE_QUESTION_SUCCESS,
});
export const fetchLanguageQuestionFailure = () => ({
    type: FETCH_LANGUAGE_QUESTION_FAILURE,
});
export const translateQuestions = (payload) => ({
    type: TRANSLATE_QUESTIONS,
    payload,
});
export const translateQuestionsSuccess = () => ({
    type: TRANSLATE_QUESTIONS_SUCCESS,
});
export const translateQuestionsFailure = () => ({
    type: TRANSLATE_QUESTIONS_FAILURE,
});
export const fetchPsychometricRoles = () => ({
    type: FETCH_PSYCHOMETRIC_ROLES,
});
export const fetchPsychometricRolesSuccess = (payload) => ({
    type: FETCH_PSYCHOMETRIC_ROLES_SUCCESS,
    payload,
});
export const fetchPsychometricRolesFailure = () => ({
    type: FETCH_PSYCHOMETRIC_ROLES_FAILURE,
});

export const createOrUpdateQuestion = (payload) => ({
    type: POST_QUESTION,
    payload,
});
export const createOrUpdateQuestionSuccess = () => ({
    type: POST_QUESTION_SUCCESS,
});
export const createOrUpdateQuestionFailure = (payload) => ({
    type: POST_QUESTION_FAILURE,
    payload,
});
export const deleteQuestionSet = (payload) => ({
    type: DELETE_QUESTION_SET,
    payload,
});
export const deleteQuestionSetSuccess = (payload) => ({
    type: DELETE_QUESTION_SET_SUCCESS,
    payload,
});
export const deleteQuestionSetFailure = () => ({
    type: DELETE_QUESTION_SET_FAILURE,
});
export const getQuestions = (payload) => ({
    type: GET_QUESTIONS,
    payload,
});
export const getQuestionsSuccess = (payload) => ({
    type: GET_QUESTIONS_SUCCESS,
    payload,
});
export const getQuestionsFailure = () => ({
    type: GET_QUESTIONS_FAILURE,
});
export const generateQuestion = (payload) => ({
    type: GENERATE_QUESTION,
    payload,
});
export const generateQuestionSuccess = () => ({
    type: GENERATE_QUESTION_SUCCESS,
});
export const generateQuestionFailure = () => ({
    type: GENERATE_QUESTION_FAILURE,
});
export const getQuestionLibrary = () => ({
    type: GET_QUESTION_LIBRARY,
});
export const getQuestionLibrarySuccess = (payload) => ({
    type: GET_QUESTION_LIBRARY_SUCCESS,
    payload,
});
export const getQuestionLibraryFailure = () => ({
    type: GET_QUESTION_LIBRARY_FAILURE,
});

export const getAllPermission = () => ({
    type: GET_ALL_PERMISSION,
});
export const getAllPermissionSuccess = (payload) => ({
    type: GET_ALL_PERMISSION_SUCCESS,
    payload,
});
export const getAllPermissionFailure = () => ({
    type: GET_ALL_PERMISSION_FAILURE,
});
